<div data-cy="context-sidebar-panel__page">
    <div class="flex align-center px-20 py-20 gap-15 right-panel-header">
        <span class="iq-badge">
            <img src="../../../../../../assets/png/iq_analysis_white.png" alt="IQ">
        </span>
        <span class="generic-clr">
            {{ totalItems }} {{ 'contexts.context_items' | transloco }} {{'contexts.items_found' | transloco}}
        </span>
        <!-- <span class="pull-right mr-10 close-icon">
            <mat-icon (click)="closePanel()" class="d-text-middle d-cursor-hand uil uil-multiply mb-4"></mat-icon>
        </span> -->
    </div>

    <div class="right-panel-body py-20">
        <div class="flex align-center gap-20 mb-10 px-20">
            <div class="title-box"></div>
            <h3>{{ 'ai_analysis.analysis_area' | transloco }}</h3>
        </div>
        <div class="flex gap-20 px-20">
            <span class="star-badge"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
            <span>
               {{ 'ai_analysis.analysis_descp' | transloco }}
            </span>
        </div>

        <mat-tab-group class="mt-20" (selectedTabChange)="onTabChange($event)">
            <!-- Context Tab -->
            <mat-tab label="Context">
                <div class="scroll stick">
                    <div class="flex align-center gap-10 px-10 py-20 chips-wrapper">
                        <div *ngFor="let item of contextChipsTypes" class="context-chip flex align-center justify-center gap-6 px-5 py-5 col-xs-2" [class.active]="activeChipId === item.id" (click)="onChipClick(item.id)">
                            <i [class]="'uil uil-'+item.icon"></i>
                            <h3>{{ 'contexts.context_type.' + item.name.toLowerCase() | transloco }}</h3>
                            <span class="chip-count" [ngStyle]="{'background-color': activeChipId === item.id ? '#2800d2' : '#808080'}">{{calculateContextItems(item.name)}}</span>
                        </div>
                    </div>
                </div>

                <div class="px-20 py-20 accordins-grp">
                    <div class="bg-white" *ngFor="let item of contextChipsTypes; let i = index" [attr.id]="'accordion-' + item.id">
                        <div class="full-width accordin-head flex align-center gap-20">
                            <span class="header-icon-box">
                                <i [class]="'uil uil-'+item.icon"></i>
                            </span>
                            <span class="chip-count">{{ calculateContextItems(item.name) }}</span>
                            <span class="accordin-title">{{ 'contexts.context_type.' + item.name.toLowerCase() | transloco }}</span>

                            <!-- Add to Project -->
                            <div class="ml-auto flex align-center">
                                <div class="flex align-center mt-6 mr-10">
                                    <button data-cy="context-sidebar-panel__add-bulk-context-items-to-project-btn" mat-flat-button [disabled]="calculateContextItems(item.name)==0 || createdContextTypes().has(item.name) || processingType()==item.name || isSharedSubproject()" (click)="addBulkContextItemsToProject(item.name)">
                                        <i class="d-text-middle uil uil-plus-circle unicon-icon"></i>
                                        <span>{{ 'contexts.add_all_items' | transloco }}</span>
                                    </button>
                                    <mat-spinner [diameter]="20" *ngIf="isProcessing() && processingType() === item.name"></mat-spinner>
                                </div>

                                <span data-cy="context-sidebar-panel__action" class="accordin-arrow mr-8 d-cursor-hand" *ngIf="calculateContextItems(item.name)!=0" (click)="contextChipsTypes[i].expanded = !contextChipsTypes[i].expanded">
                                    <i class="uil uil-angle-up" *ngIf="false"></i>
                                    <i class="uil uil-angle-down"></i>
                                </span>
                            </div>
                        </div>
                        <div class="accordin-body flex px-20 py-25" *ngIf="item.expanded">
                            <!-- progress-card.component.html -->
                            <ng-container
                                *ngTemplateOutlet="metricesCard;
                                context: { $implicit: { value: getContextDataByType(item.name), type : item.name } }"
                            ></ng-container>

                            <ng-template #metricesCard let-context>
                                <!-- <ng-container *ngIf="context"> -->
                                    <ng-container *ngIf="context.type !== 'Physical' && context?.value">
                                        <p class="clr-black px-15">{{ context.value?.summary }}</p>
                                        <!-- <div class="detail-table-card1 col-xs-12 mb-10 px-0" *ngFor="let item of context?.value?.context_subtypes" (mouseleave)="expandedItem()?.item !== item && onLeaveContextItem()" (mouseenter)="expandedItem()?.item !== item && onHoverContextItem(context.type, item)"> -->
                                        <div class="detail-table-card1 col-xs-12 mb-10 px-0" *ngFor="let item of context?.value?.context_subtypes">
                                            <div class="px-15 py-15 card1-title flex align-center justify-btw d-cursor-hand" (click)="openIndividualContextDetail(item, context.type)">
                                                <h3 class="generic-clr ts-13 mb-0 mt-0">{{ item.context_subtype }}</h3>
                                                <i
                                                    class="uil"
                                                    [class.uil-angle-down]="expandedItem()?.item !== item"
                                                    [class.uil-angle-up]="expandedItem()?.item === item"
                                                ></i>
                                            </div>
                                            <div class="px-15 py-15">
                                                <p> {{ item.context_subtype_summary }} </p>
                                                <span class="mt-6">{{ item.context_items?.length || 0 }} {{ getContextLabel(context.type, item.context_items?.length || 0) | transloco }}</span>
                                            </div>
                                            <ng-container *ngIf="expandedItem()?.item === item && expandedItem()?.type === context.type">
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                    IndividualContextDetail;
                                                    context: { $implicit: { item, type: context.type } }
                                                    "
                                                ></ng-container>
                                            </ng-container>
                                        </div>

                                        <!-- For already created contexts -->
                                        <!-- <div class="detail-table-card1 col-xs-12 mb-10 px-0" *ngFor="let item of context?.value?.context_items" (mouseleave)="expandedItem()?.item !== item && onLeaveContextItem()" (mouseenter)="expandedItem()?.item !== item && onHoverContextItem(context.type, item)"> -->
                                        <div class="detail-table-card1 col-xs-12 mb-10 px-0" *ngFor="let item of context?.value?.context_items">
                                            <div class="px-15 py-15 card1-title flex align-center justify-btw d-cursor-hand" (click)="openIndividualContextDetail(item, context.type)">
                                                <h3 class="generic-clr ts-13 mb-0 mt-0">{{ item.text }}</h3>
                                                <i
                                                    class="uil"
                                                    [class.uil-angle-down]="expandedItem()?.item !== item"
                                                    [class.uil-angle-up]="expandedItem()?.item === item"
                                                ></i>
                                            </div>
                                            <div class="px-15 py-15">
                                                <p> {{ item?.description }} </p>
                                                <span class="mt-6">{{ context.type === 'Regulatory' ? ('contexts.one_plan' | transloco) : context.type === 'Political' ? ('contexts.one_municipality' | transloco) : ('contexts.one_neighborhood' | transloco)}}</span>
                                            </div>
                                            <ng-container *ngIf="expandedItem()?.item === item && expandedItem()?.type === context.type">
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                    IndividualContextDetail;
                                                    context: { $implicit: { item, type: context.type } }
                                                    "
                                                ></ng-container>
                                            </ng-container>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="context.type === 'Physical'">
                                        <div class="detail-table-card1 col-xs-12 mb-10 px-0" *ngFor="let item of context.value">
                                            <!-- (mouseenter)="expandedItem()?.item !== item && onHoverContextItem(context.type, item)"
                                            (mouseleave)="expandedItem()?.item !== item && onLeaveContextItem()"> -->
                                            <div class="px-15 py-15 card1-title flex align-center justify-btw d-cursor-hand" (click)="openIndividualContextDetail(item, context.type)">
                                                <h3 class="generic-clr ts-13 mb-0 mt-0">{{ item.text | capitaliz}}</h3>
                                                <i
                                                    class="uil"
                                                    [class.uil-angle-down]="expandedItem()?.item.uuid !== item.uuid"
                                                    [class.uil-angle-up]="expandedItem()?.item.uuid === item.uuid"
                                                ></i>
                                            </div>
                                            <div class="px-15 py-15">
                                                <p> {{ (item.amenity ? getPhysicalLabel(item.amenity) : item.operator ? getPhysicalLabel(item.operator) : item.text ) | capitaliz }} </p>
                                            </div>
                                            <ng-container *ngIf="expandedItem()?.item.uuid === item.uuid && expandedItem()?.type === context.type">
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                    IndividualContextDetail;
                                                    context: { $implicit: { item, type: context.type } }
                                                    "
                                                ></ng-container>
                                            </ng-container>
                                        </div>
                                    </ng-container>

                            </ng-template>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <!-- Stakeholders Tab -->
            <mat-tab label="Stakeholders">
                <div class="cards px-15 py-15" >
                    <!-- <div class="detail-table-card1 px-0 card mb-15" *ngFor="let stakeholder of transformedStakeholders" (mouseenter)="onHoverStakeholder(stakeholder)" (mouseleave)="onLeaveContextItem()" > -->
                    <div class="detail-table-card1 px-0 card mb-15" *ngFor="let stakeholder of transformedStakeholders">
                        <div class="px-15 py-15 card-header flex align-center justify-btw d-cursor-hand" (click)="openIndividualContextDetail(stakeholder, 'Stakeholder')">
                            <h3 class="generic-clr ts-13 mb-0 mt-0"> {{ stakeholder.name || ('contexts.no_stakeholder' | transloco) }}</h3>
                            <i
                                class="uil"
                                [class.uil-angle-down]="expandedItem()?.item !== stakeholder"
                                [class.uil-angle-up]="expandedItem()?.item === stakeholder"
                            ></i>
                        </div>
                        <div class="px-15 py-15 card-body">
                            <!-- Stakeholder address -->
                            <p><strong>{{ 'contexts.address' | transloco }}:</strong>
                                {{ stakeholder.address || ('contexts.no_address_available' | transloco) }}
                            </p>
                            <!-- Contexts -->
                            <!-- <p><strong>{{ 'contexts.context' | transloco }}:</strong>
                                <span *ngFor="let context of stakeholder.contexts; let last = last">
                                    {{ context.text }}<span *ngIf="!last">, </span>
                                </span>
                            </p> -->
                        </div>
                        <ng-container *ngIf="areBothEqual(expandedItem()?.item, stakeholder.contextUuid) && expandedItem()?.type === 'Stakeholder'">
                            <ng-container
                                *ngTemplateOutlet="
                                IndividualContextDetail;
                                context: { $implicit: { item: stakeholder, type: 'Stakeholder' } }
                                "
                            ></ng-container>
                        </ng-container>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

<ng-template #IndividualContextDetail let-data>
    <app-individual-context-detail [contextItemDetail]="data" (onLeaveContext)="onLeaveContextItem()" (onHoverContext)="onHoverContextItem($event.type, $event.item)" (onItemSelection)="onClickSingleItem($event)"></app-individual-context-detail>
</ng-template>
